
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

export default class PageEightController {
    constructor($log, $state, $timeout, $interval, Session, Dialog) {
        'ngInject'; 
        this.$log = $log;  
        this.$state = $state;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.Session = Session;
        this.Dialog = Dialog;
    }
    $onInit(){
        this.$timeout(this.initializeCarousel.bind(this));
        this.embeddeds = {
            carta1: require('_images/page-eight/caixa_carta1.png'),
            carta2: require('_images/page-eight/caixa_carta2.png'),
            parabens: require('_images/page-eight/Caixa_parabens.png'),
        }
    }

    openDialogs(){
        this.Dialog.showEmbedded(this.embeddeds.carta1, 2000, this.nextDialog.bind(this));
    }

    nextDialog(){
        this.Dialog.showEmbedded(this.embeddeds.carta2, 2000, this.lastDialog.bind(this));
    }

    lastDialog(){
        this.Dialog.showEmbedded(this.embeddeds.parabens, 0, this.nextStage.bind(this));
    }

    $onDestroy(){
        this.resetStage();
    }
    
    resetStage() {        
        return false;
    }

    nextStage(){
        this.$timeout(() => this.$state.go("page-nine"), 300);
    }

    redirectToStages(){
        this.$state.go("page-nine");
    }

    initializeCarousel(){
        $('.letters-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            fade: true
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-eight/page-eight.controller.js